import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const fetchArticles = (params) =>
  axios.get(`${API}/blog/articles`, { params }).then((r) => r.data);

export const fetchArticle = (slug) =>
  axios.get(`${API}/blog/articles/${slug}`).then((r) => r.data);

export const fetchCategories = () =>
  axios.get(`${API}/blog/categories`).then((r) => r.data);

const authHeaders = (token) => ({ headers: { Authorization: `Bearer ${token}` } });

export const adminApi = {
  me: (token) => axios.get(`${API}/admin/blog/me`, authHeaders(token)).then((r) => r.data),
  listArticles: (token) => axios.get(`${API}/admin/blog/articles`, authHeaders(token)).then((r) => r.data),
  getArticle: (token, id) => axios.get(`${API}/admin/blog/articles/${id}`, authHeaders(token)).then((r) => r.data),
  createArticle: (token, data) => axios.post(`${API}/admin/blog/articles`, data, authHeaders(token)).then((r) => r.data),
  updateArticle: (token, id, data) => axios.put(`${API}/admin/blog/articles/${id}`, data, authHeaders(token)).then((r) => r.data),
  deleteArticle: (token, id) => axios.delete(`${API}/admin/blog/articles/${id}`, authHeaders(token)).then((r) => r.data),
  uploadImage: (token, file) => {
    const fd = new FormData();
    fd.append("file", file);
    return axios.post(`${API}/admin/blog/upload`, fd, authHeaders(token)).then((r) => r.data);
  },
  listEditors: (token) => axios.get(`${API}/admin/blog/editors`, authHeaders(token)).then((r) => r.data),
  createEditor: (token, data) => axios.post(`${API}/admin/blog/editors`, data, authHeaders(token)).then((r) => r.data),
  deleteEditor: (token, userId) => axios.delete(`${API}/admin/blog/editors/${userId}`, authHeaders(token)).then((r) => r.data),
};
